<template>
  <div class="app-container">
    <el-button style="margin-right:12px;" type="success" @click="handleClick()" size="small">
      <svg-icon icon-class="export" class-name="imporst-icon"></svg-icon>导出
    </el-button>
  </div>
</template>

<script>
/**
 * 通用导出按钮组件
 * 功能：调用 exportExcel 将后端 blob 下载为 CSV 文件
 */
import { exportExcel } from "@/api/user";
export default {
  props: {
    url: {
      type: String,
      default: "",
    },
    param: {
      type: Object,
      default: () => {
        return {};
      },
    },
    fileName: { type: String, default: "" },
    requestType: { type: String, default: "" },
  },
  data() {
    return {};
  },
  methods: {
    /** 点击导出，将后端返回的 blob 数据下载为 CSV 文件 */
    handleClick() {
      exportExcel(this.param, this.url, this.requestType).then((result) => {
        let blob = new Blob([result], {
          type: "text/plain;charset=utf-8;",
        });
        var now = new Date();
        var yy = now.getFullYear(); //年
        var mm = now.getMonth() + 1; //月
        var dd = now.getDate();
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = this.fileName + yy + mm + dd + ".csv"; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      });
    },
  },
};
</script>
